import WebAPI from './WebAPI'

const API_ROOT_ES = process.env.API_ROOT_ES

class ElasticsearchAPI extends WebAPI {
  constructor () {
    super({baseURL: API_ROOT_ES})
  }

  async universeEstimate (payload) {
    return this.__post({
      extensionURL: '/UniverseEstimate',
      payload
    })
  }

  async targetDefinition (payload) {
    return this.__post({
      extensionURL: '/TargetDefinition',
      payload
    })
  }

  async historicalViewership (payload) {
    return this.__post({
      extensionURL: '/HistoricalViewership',
      payload
    })
  }

  async age (payload) {
    return this.__post({
      extensionURL: '/Age',
      payload
    })
  }

  async income (payload) {
    return this.__post({
      extensionURL: '/Income',
      payload
    })
  }

  async metrics (payload) {
    return this.__post({
      extensionURL: '/Metrics',
      payload
    })
  }

  async broadcastDates (payload) {
    return this.__post({
      extensionURL: '/BroadcastDates',
      payload
    })
  }
}

export default new ElasticsearchAPI()




// WEBPACK FOOTER //
// ./src/app/api/ElasticsearchAPI.js